//PreDimension.js


//------------------------------------------------------------------------------------------
//												IMPORT
//------------------------------------------------------------------------------------------

import * as ProfilLibrary from "../classes/ProfilLibrary.js";

import store from '../store/index.js';
store.getters.config;


//------------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------------
//						SOME LISTS: for assigning profiles, areas, ...
//------------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------------

//IPE
//------------------------------------------------------------------------------------------
function IPE(id, height, area, shape) {
	this.id = id;
	this.height = height;
	this.area = area;
	this.shape = shape;
}

var IPEProfiles = [
	new IPE ( "IPE 160", 16, 20.1, ProfilLibrary.IPEShapes[0]  ),
	new IPE ( "IPE 180", 18, 23.9, ProfilLibrary.IPEShapes[1]  ),
	new IPE ( "IPE 200", 20, 28.5, ProfilLibrary.IPEShapes[2]  ),
	new IPE ( "IPE 220", 22, 33.4, ProfilLibrary.IPEShapes[3]  ),
	new IPE ( "IPE 240", 24, 39.1, ProfilLibrary.IPEShapes[4]  ),
	new IPE ( "IPE 270", 27, 45.9, ProfilLibrary.IPEShapes[5]  ),
	new IPE ( "IPE 300", 30, 53.8, ProfilLibrary.IPEShapes[6]  ),
	new IPE ( "IPE 330", 33, 62.6, ProfilLibrary.IPEShapes[7]  ),
	new IPE ( "IPE 360", 36, 72.7, ProfilLibrary.IPEShapes[8]  ),
	new IPE ( "IPE 400", 40, 84.5, ProfilLibrary.IPEShapes[9]  ),
	new IPE ( "IPE 450", 45, 98.8, ProfilLibrary.IPEShapes[10] ),
	new IPE ( "IPE 500", 50, 116,  ProfilLibrary.IPEShapes[11] ),
	new IPE ( "IPE 550", 55, 134,  ProfilLibrary.IPEShapes[12] ),
	new IPE ( "IPE 600", 60, 156,  ProfilLibrary.IPEShapes[13] )
]


//HEB
//------------------------------------------------------------------------------------------
function HEB(id, height, area, shape) {
	this.id = id;
	this.height = height;
	this.area = area;
	this.shape = shape;
}

var HEBProfiles = [
	new HEB ( "HEB 160",  16, 54.3, ProfilLibrary.HEBShapes[0]  ),
	new HEB ( "HEB 180",  18, 65.3, ProfilLibrary.HEBShapes[1]  ),
	new HEB ( "HEB 200",  20, 78.1, ProfilLibrary.HEBShapes[2]  ),
	new HEB ( "HEB 220",  22, 91.0, ProfilLibrary.HEBShapes[3]  ),
	new HEB ( "HEB 240",  24, 106,  ProfilLibrary.HEBShapes[4]  ),
	new HEB ( "HEB 260",  26, 118,  ProfilLibrary.HEBShapes[5]  ),
	new HEB ( "HEB 280",  28, 131,  ProfilLibrary.HEBShapes[6]  ),
	new HEB ( "HEB 300",  30, 149,  ProfilLibrary.HEBShapes[7]  ),
	new HEB ( "HEB 320",  32, 161,  ProfilLibrary.HEBShapes[8]  ),
	new HEB ( "HEB 340",  32, 171,  ProfilLibrary.HEBShapes[9]  ),
	new HEB ( "HEB 360",  36, 181,  ProfilLibrary.HEBShapes[10] ),
	new HEB ( "HEB 400",  40, 198,  ProfilLibrary.HEBShapes[11] ),
	new HEB ( "HEB 450",  45, 218 , ProfilLibrary.HEBShapes[12] ),
	new HEB ( "HEB 500",  50, 239 , ProfilLibrary.HEBShapes[13] ),
	new HEB ( "HEB 550",  55, 254,  ProfilLibrary.HEBShapes[14] ),
	new HEB ( "HEB 600",  60, 270,  ProfilLibrary.HEBShapes[15] ),
	new HEB ( "HEB 650",  65, 286,  ProfilLibrary.HEBShapes[16] ),
	new HEB ( "HEB 700",  70, 306,  ProfilLibrary.HEBShapes[17] ),
	new HEB ( "HEB 800",  80, 334 , ProfilLibrary.HEBShapes[18] ),
	new HEB ( "HEB 900",  90, 371,  ProfilLibrary.HEBShapes[19] ),
	new HEB ( "HEB 1000", 100,400,  ProfilLibrary.HEBShapes[20] )
]


//KLH Ribbed Slabs
//------------------------------------------------------------------------------------------
function KLHRibbedSlab(deadLoad, liveLoad, ribHeight6m, ribHeight7m, ribHeight8m, ribHeight9m, ribHeight10m) {
	this.deadLoad = deadLoad;
	this.liveLoad = liveLoad;
	this.ribHeight6m = ribHeight6m;
	this.ribHeight7m = ribHeight7m;
	this.ribHeight8m = ribHeight8m;
	this.ribHeight9m = ribHeight9m;
	this.ribHeight10m = ribHeight10m;
}

var KLHRibbedSlabs = [
	//Dead load - 1.0
	new KLHRibbedSlab (1.0, 1.5, 16, 20, 24, 28, 36 ),
	new KLHRibbedSlab (1.0, 2.0, 16, 20, 24, 28, 36 ),
	new KLHRibbedSlab (1.0, 2.8, 16, 20, 24, 28, 36 ),
	new KLHRibbedSlab (1.0, 3.0, 16, 20, 24, 28, 36 ),
	new KLHRibbedSlab (1.0, 3.5, 16, 20, 24, 28, 36 ),
	new KLHRibbedSlab (1.0, 4.0, 20, 24, 28, 32, 36 ),
	new KLHRibbedSlab (1.0, 5.0, 20, 24, 28, 36, 40 ),

	//Dead load - 1.5
	new KLHRibbedSlab (1.5, 1.5, 16, 20, 24, 32, 36 ),
	new KLHRibbedSlab (1.5, 2.0, 16, 20, 24, 32, 36 ),
	new KLHRibbedSlab (1.5, 2.8, 16, 20, 24, 32, 36 ),
	new KLHRibbedSlab (1.5, 3.0, 16, 20, 24, 32, 36 ),
	new KLHRibbedSlab (1.5, 3.5, 16, 20, 24, 32, 36 ),
	new KLHRibbedSlab (1.5, 4.0, 20, 24, 28, 36, 40 ),
	new KLHRibbedSlab (1.5, 5.0, 20, 24, 32, 36, 40 ),

	//Dead load - 2.0
	new KLHRibbedSlab (2.0, 1.5, 16, 20, 28, 36, 40 ),
	new KLHRibbedSlab (2.0, 2.0, 16, 20, 28, 36, 40 ),
	new KLHRibbedSlab (2.0, 2.8, 16, 20, 28, 36, 40 ),
	new KLHRibbedSlab (2.0, 3.0, 16, 24, 28, 36, 40 ),
	new KLHRibbedSlab (2.0, 3.5, 16, 24, 28, 36, 40 ),
	new KLHRibbedSlab (2.0, 4.0, 20, 24, 32, 36, 40 ),
	new KLHRibbedSlab (2.0, 5.0, 20, 28, 32, 36, 40 ),

	//Dead load - 2.5
	new KLHRibbedSlab (2.5, 1.5, 16, 24, 32, 36, 44 ),
	new KLHRibbedSlab (2.5, 2.0, 16, 24, 32, 36, 44 ),
	new KLHRibbedSlab (2.5, 2.8, 20, 24, 32, 36, 44 ),
	new KLHRibbedSlab (2.5, 3.0, 20, 24, 32, 36, 44 ),
	new KLHRibbedSlab (2.5, 3.5, 20, 24, 32, 36, 44 ),
	new KLHRibbedSlab (2.5, 4.0, 20, 28, 32, 36, 44 ),
	new KLHRibbedSlab (2.5, 5.0, 24, 28, 32, 40, 44 ),

	//Dead load - 3.0
	new KLHRibbedSlab (3.0, 1.5, 20, 24, 32, 40, 48 ),
	new KLHRibbedSlab (3.0, 2.0, 20, 24, 32, 40, 48 ),
	new KLHRibbedSlab (3.0, 2.8, 20, 24, 32, 40, 48 ),
	new KLHRibbedSlab (3.0, 3.0, 20, 24, 32, 40, 48 ),
	new KLHRibbedSlab (3.0, 3.5, 20, 24, 32, 40, 48 ),
	new KLHRibbedSlab (3.0, 4.0, 24, 28, 32, 40, 48 ),
	new KLHRibbedSlab (3.0, 5.0, 24, 28, 36, 40, 48 ),
]


//HBV Ribbed Slabs
//------------------------------------------------------------------------------------------
function HBVRibbedSlab( deadLoad, liveLoad, heightConcrete5m,  widthTimber5m,  heightTimber5m,  distance5m, 
	heightConcrete6m,  widthTimber6m,  heightTimber6m,  distance6m, 
	heightConcrete7m,  widthTimber7m,  heightTimber7m,  distance7m, 
	heightConcrete8m,  widthTimber8m,  heightTimber8m,  distance8m, 
	heightConcrete9m,  widthTimber9m,  heightTimber9m,  distance9m, 
	heightConcrete10m, widthTimber10m, heightTimber10m, distance10m) {

	this.deadLoad = deadLoad;
	this.liveLoad = liveLoad;

	//Span - 5m 
	this.heightConcrete5m = heightConcrete5m;
	this.widthTimber5m = widthTimber5m;
	this.heightTimber5m = heightTimber5m;
	this.distance5m = distance5m;
	//Span - 6m 
	this.heightConcrete6m = heightConcrete6m;
	this.widthTimber6m = widthTimber6m;
	this.heightTimber6m = heightTimber6m;
	this.distance6m = distance6m;
	//Span - 7m 
	this.heightConcrete7m = heightConcrete7m;
	this.widthTimber7m = widthTimber7m;
	this.heightTimber7m = heightTimber7m;
	this.distance7m = distance7m;
	//Span - 8m 
	this.heightConcrete8m = heightConcrete8m;
	this.widthTimber8m = widthTimber8m;
	this.heightTimber8m = heightTimber8m;
	this.distance8m = distance8m;
	//Span - 9m 
	this.heightConcrete9m = heightConcrete9m;
	this.widthTimber9m = widthTimber9m;
	this.heightTimber9m = heightTimber9m;
	this.distance9m = distance9m;
	//Span - 10m 
	this.heightConcrete10m = heightConcrete10m;
	this.widthTimber10m = widthTimber10m;
	this.heightTimber10m = heightTimber10m;
	this.distance10m = distance10m;
}

var HBVRibbedSlabs = [
									//Span - 5m					//Span - 6m					//Span - 7m					//Span - 8m					//Span - 9m					//Span - 10m	
	new HBVRibbedSlab (1.0,  1.5,	0.10,  0.08,  0.16,  0.90,  0.08,  0.12,  0.16,  0.80,  0.12,  0.16,  0.20,  1.00,  0.12,  0.14,  0.24,  0.90,  0.12,  0.16,  0.30,  0.95,  0.12,  0.20,  0.36,  1.00),
	new HBVRibbedSlab (1.5,  1.5,	0.10,  0.08,  0.16,  0.70,  0.08,  0.12,  0.16,  0.70,  0.12,  0.16,  0.20,  0.95,  0.12,  0.16,  0.24,  0.90,  0.12,  0.16,  0.32,  1.00,  0.12,  0.20,  0.38,  1.00),
	new HBVRibbedSlab (1.5,  2.25,	0.10,  0.08,  0.16,  0.75,  0.10,  0.12,  0.20,  0.90,  0.12,  0.16,  0.24,  0.95,  0.12,  0.16,  0.28,  0.95,  0.12,  0.16,  0.32,  1.00,  0.12,  0.20,  0.38,  1.10),
	new HBVRibbedSlab (1.75, 2.25,  0.10,  0.08,  0.16,  0.70,  0.10,  0.12,  0.20,  0.90,  0.12,  0.16,  0.24,  0.95,  0.12,  0.16,  0.28,  0.90,  0.12,  0.16,  0.34,  1.05,  0.12,  0.20,  0.40,  1.20),
	new HBVRibbedSlab (1.75, 2.75,  0.10,  0.08,  0.16,  0.65,  0.10,  0.12,  0.20,  0.85,  0.12,  0.16,  0.24,  0.90,  0.12,  0.16,  0.28,  1.00,  0.12,  0.16,  0.36,  1.15,  0.12,  0.20,  0.40,  1.20),
	new HBVRibbedSlab (1.75, 3.50,  0.10,  0.08,  0.20,  0.75,  0.10,  0.12,  0.20,  0.70,  0.12,  0.16,  0.24,  0.90,  0.12,  0.16,  0.32,  1.10,  0.12,  0.18,  0.36,  1.15,  0.12,  0.20,  0.40,  1.20),
	new HBVRibbedSlab (1.75, 5.00,  0.10,  0.08,  0.20,  0.60,  0.10,  0.16,  0.20,  0.70,  0.12,  0.16,  0.28,  0.90,  0.12,  0.16,  0.32,  0.90,  0.12,  0.20,  0.36,  1.05,  0.12,  0.24,  0.40,  1.15),	
]


//KLH CLT-Slab
//------------------------------------------------------------------------------------------
function KLHCLTSlab(deadLoad, liveLoad, height3m, height4m, height5m, height6m, height7m) {
	this.deadLoad = deadLoad;
	this.liveLoad = liveLoad;
	this.height3m = height3m;
	this.height4m = height4m;
	this.height5m = height5m;
	this.height6m = height6m;
	this.height7m = height7m;
}

var KLHCLTSlabs = [
	//Dead load - 1.0
	new KLHCLTSlab (1.0, 1.5, 10, 12, 15, 16, 20 ),
	new KLHCLTSlab (1.0, 2.0, 10, 12, 15, 16, 20 ),
	new KLHCLTSlab (1.0, 2.8, 10, 12, 15, 16, 20 ),
	new KLHCLTSlab (1.0, 3.0, 10, 12, 15, 16, 20 ),
	new KLHCLTSlab (1.0, 3.5, 10, 12, 15, 17, 22 ),
	new KLHCLTSlab (1.0, 4.0, 10, 13, 15, 19, 22 ),
	new KLHCLTSlab (1.0, 5.0, 10, 14, 16, 20, 24 ),

	//Dead load - 1.5
	new KLHCLTSlab (1.5, 1.5, 10, 12, 15, 18, 20 ),
	new KLHCLTSlab (1.5, 2.0, 10, 12, 15, 18, 20 ),
	new KLHCLTSlab (1.5, 2.8, 10, 12, 15, 18, 22 ),
	new KLHCLTSlab (1.5, 3.0, 10, 12, 15, 18, 22 ),
	new KLHCLTSlab (1.5, 3.5, 10, 13, 15, 18, 22 ),
	new KLHCLTSlab (1.5, 4.0, 10, 13, 16, 20, 22 ),
	new KLHCLTSlab (1.5, 5.0, 10, 14, 17, 20, 24 ),

	//Dead load - 2.0
	new KLHCLTSlab (2.0, 1.5, 10, 12, 15, 19, 24 ),
	new KLHCLTSlab (2.0, 2.0, 10, 12, 15, 19, 24 ),
	new KLHCLTSlab (2.0, 2.8, 10, 13, 15, 19, 24 ),
	new KLHCLTSlab (2.0, 3.0, 10, 13, 15, 19, 24 ),
	new KLHCLTSlab (2.0, 3.5, 10, 13, 15, 19, 24 ),
	new KLHCLTSlab (2.0, 4.0, 10, 13, 17, 20, 24 ),
	new KLHCLTSlab (2.0, 5.0, 11, 14, 18, 20, 24 ),

	//Dead load - 2.5
	new KLHCLTSlab (2.5, 1.5, 10, 13, 16, 19, 24 ),
	new KLHCLTSlab (2.5, 2.0, 10, 13, 16, 19, 24 ),
	new KLHCLTSlab (2.5, 2.8, 10, 13, 16, 19, 24 ),
	new KLHCLTSlab (2.5, 3.0, 10, 13, 16, 19, 24 ),
	new KLHCLTSlab (2.5, 3.5, 10, 13, 16, 20, 24 ),
	new KLHCLTSlab (2.5, 4.0, 11, 14, 18, 22, 24 ),
	new KLHCLTSlab (2.5, 5.0, 11, 14, 18, 22, 24 ),

	//Dead load - 3.0
	new KLHCLTSlab (3.0, 1.5, 10, 13, 16, 19, 24 ),
	new KLHCLTSlab (3.0, 2.0, 10, 13, 16, 19, 24 ),
	new KLHCLTSlab (3.0, 2.8, 10, 13, 16, 19, 24 ),
	new KLHCLTSlab (3.0, 3.0, 10, 13, 16, 19, 24 ),
	new KLHCLTSlab (3.0, 3.5, 10, 13, 16, 22, 24 ),
	new KLHCLTSlab (3.0, 4.0, 11, 14, 18, 22, 26 ),
	new KLHCLTSlab (3.0, 5.0, 12, 14, 19, 22, 26 ),
]


//GlulamColumn
//------------------------------------------------------------------------------------------
function GlulamColumn(sideLength, columnLoad3m, columnLoad3_5m, columnLoad4m, columnLoad4_5m, 
	columnLoad5m, columnLoad5_5m, columnLoad6m) {

	this.sideLength = sideLength;
	this.columnLoad3m =		columnLoad3m;
	this.columnLoad3_5m =	columnLoad3_5m;
	this.columnLoad4m =		columnLoad4m;
	this.columnLoad4_5m =	columnLoad4_5m;
	this.columnLoad5m =		columnLoad5m;
	this.columnLoad5_5m =	columnLoad5_5m;
	this.columnLoad6m =		columnLoad6m;
}


var GlulamColumns= [
						//Height	//3.0m	//3.5m	//4.0m	//4.5m	//5.0m	//5.5m	//6.0m	
	new GlulamColumn(	0.14,		195,	150,	118,	94.5,	77.2,	64.3,	54.3	), 
	new GlulamColumn(	0.16,		307,	246,	196,	158,	130,	108,	91.8	), 
	new GlulamColumn(	0.18,		436,	371,	304,	248,	205,	172,	145		), 
	new GlulamColumn(	0.20,		574,	516,	441,	368,	307,	258,	219		), 
	new GlulamColumn(	0.22,		720,	673,	601,	517,	438,	371,	317		), 
	new GlulamColumn(	0.24,		877,	837,	775,	691,	599,	514,	442		), 
	new GlulamColumn(	0.26,		1044,	1010,	958,	882,	786,	687,	596		), 
	new GlulamColumn(	0.28,		1224,	1193,	1149,	1083,	993,	887,	781		), 
	new GlulamColumn(	0.30,		1416,	1388,	1348,	1292,	1108,	1108,	993		),
	new GlulamColumn(	0.32,		1711,	1676,	1640,	1570,	1499,	1393,	1252	),
	new GlulamColumn(	0.34,		1932,	1912,	1872,	1812,	1752,	1653,	1513	),
	new GlulamColumn(	0.36,		2188,	2166,	2121,	2076,	2009,	1920,	1808	),
	new GlulamColumn(	0.38,		2438,	2413,	2388,	2338,	2288,	2189,	2089	),
	new GlulamColumn(	0.40,		2701,	2674,	2646,	2618,	2563,	2481,	2398	),
	new GlulamColumn(	0.42,		3008,	2978,	2948,	2887,	2857,	2796,	2705	),
	new GlulamColumn(	0.44,		3302,	3269,	3235,	3202,	3168,	3102,	3035	),
	new GlulamColumn(	0.46,		3609,	3572,	3572,	3500,	3463,	3427,	3354	),
	new GlulamColumn(	0.48,		3930,	3930,	3890,	3850,	3811,	3731,	3691	),
	new GlulamColumn(	0.50,		4307,	4264,	4221,	4178,	4135,	4092,	4049	),
	new GlulamColumn(	0.52,		4658,	4612,	4565,	4565,	4519,	4472,	4379	),
	new GlulamColumn(	0.54,		5024,	4974,	4974,	4923,	4873,	4823,	4773	),
	new GlulamColumn(	0.56,		5403,	5349,	5349,	5295,	5241,	5187,	5133	),
	new GlulamColumn(	0.58,		5796,	5796,	5738,	5680,	5680,	5622,	5564	),
	new GlulamColumn(	0.60,		6202,	6202,	6140,	6078,	6078,	6016,	5954	)
]




//--------------------------------------------------------------------------
//--------------------------------------------------------------------------
//								MAIN METHODS
//--------------------------------------------------------------------------
//--------------------------------------------------------------------------


//Slab
//--------------------------------------------------------------------------

function predimSlab(material, structSystem, spanX, spanY, beamDist, liveLoad, deadLoad) {
	var height = 0;

	//Concrete slabs
	if (material == "Concrete") {
		if (structSystem == "Plate") {
			height = predimConcreteFlatSlab(spanX, spanY);
		}
		else if (structSystem == "Beam") {
			height = predimConcreteSlab(spanX, spanY);
		}    
		else {
			console.log("Error: No structural system selected!");
		}
	}
	//Timber slabs
	else if (material == "Timber") {
		if (structSystem == "Plate") {
			height = predimCLTSlab(spanX, spanY, liveLoad, deadLoad);
		}
		else if (structSystem == "Beam") {
			height = predimRibbedTimberSlab(spanX, spanY, liveLoad, deadLoad);
		}
		else {
			console.log("Error: No structural system selected!");
		}
	}
	//Steel slabs
	else if (material == "Steel") {
		if (structSystem == "Plate") {
			height = predimHolribSlab(beamDist, liveLoad);
		}
		else if (structSystem == "Beam") {
			height = predimCompositeSlab(beamDist);
		}
		else {
			console.log("Error: No structural system selected!");
		}
	}
	//Hybrid slabs
	else if (material == "Hybrid") {
		if (structSystem == "Plate") {
			height = predimHBVSlab(spanX, spanY, liveLoad, deadLoad);
		} 
		else if (structSystem == "Beam") {
			height = predimCLTSlab(spanX, spanY, liveLoad, deadLoad);
		}
		else {
			console.log("Error: No structural system selected!");
		}
	}
	else {
		console.log("Error: No material selected!");
	}

	return height; 
}


//Column
//--------------------------------------------------------------------------
function  predimColumn(material, structSystem, load, length) {
	var area = 0;

	if (material == "Concrete") {
		area = predimConcreteColumn(load);
	}
	else if (material == "Timber") {
		area = predimTimberColumn(load, length);
	}
	else if (material == "Steel") {
		area = predimSteelColumn(load, length);
	}
	else if (material == "Hybrid") {
		if (structSystem == "Plate") {
			area = predimTimberColumn(load, length);
		}
		else {
			area = predimSteelColumn(load, length);
		}
	}
	else {
		console.log("Error: No material selected!");
	}

	return area;
}


//Beam
//--------------------------------------------------------------------------
function predimBeam(beam, material, liveLoad, deadLoad, length, xSpan, ySpan, distance, structSystem, concretePlateHeight) {

	var result = 0;

	var load = 1.35 * liveLoad + 1.5 * deadLoad;

	var loadedWidth = Math.min(xSpan, ySpan)
	//Concrete
	if (material == "Concrete" && structSystem == "Beam") {		
		result = predimConcreteTBeam(load, length, concretePlateHeight, loadedWidth);					//Load = totalLoad in kN/m2
	}
	//Timber
	else if (material == "Timber") {
		if(structSystem == "Plate") {
			if(beam.type == "Primary") {
				result = predimTimberBeam(load, length, loadedWidth);													//Load = totalLoad in kN/m2
			}
			else if(beam.type == "Secondary") {
				result = predimTimberBeam(load, length, loadedWidth);													//Load = totalLoad in kN/m2
			}
		}
		else if(structSystem == "Beam") {
			if(beam.type == "Primary") {
				result = predimTimberBeam(load, length, loadedWidth);													//Load = totalLoad in kN/m2
			}
			else if(beam.type == "Secondary") {
				result = predimDummyTimberBeam();									
			}
		}
	}
	//Steel
	else if (material == "Steel") {
		if(beam.type == "Primary") {
			result = predimCompositeSteelBeam(load, length, loadedWidth);
		}
		else if(beam.type == "Secondary") {
			result = predimCompositeSteelBeam(load, length, distance);
		}
	}
	else if (material == "Hybrid") {
		if(structSystem == "Plate")
		{
			if(beam.type == "Primary") {
				result = predimTimberBeam(load, length, loadedWidth);
			}
			else if(beam.type == "Secondary") {
				result = predimDummyTimberBeam();
			}
		}
		else if(structSystem == "Beam") {
			if(beam.type == "Primary") {
				result = predimCompositeSteelBeam(load, length, loadedWidth);
			}
			else if(beam.type == "Secondary") {
				result = predimCompositeSteelBeam(load, length, distance);
			}
		}
	}
	else {
		console.log("Error: No material selected!");
	}

	return result;
}



//--------------------------------------------------------------------------
//--------------------------------------------------------------------------
//							SINGLE MEMBER METHODS
//--------------------------------------------------------------------------
//--------------------------------------------------------------------------


//--------------------------------------------------------------------------
//Slabs
//--------------------------------------------------------------------------

//Steel slabs
//--------------------------------------------------------------------------

function predimCompositeSlab(beamDist) {

	//Concrete plate
	var height; 
	if(beamDist < 2.5) {
		height = 0.1;
	}
	else if(beamDist < 3.5) {
		height = 0.12;
	}
	else {
		height = 0.15;
	}

	height = Math.max( height, 0.10)

	console.log(`Composite slab with height: ${height} cm`);
	
	return  height;                  			 //return height in m
}


function predimHolribSlab(beamDist, liveLoad) {

	function HolribSlab(height) {
		this.height = height;
		this.profileSheetWeight = 10;				//kg/m2
	}
	
	//Concrete plate
	var height = Math.ceil( 0.75 * (3 * beamDist + 1 + (liveLoad - 1.5) ) );		//cm
	height = Math.max( height, 10)
	var holribSlab = new HolribSlab(height/100);								//return height in m

	console.log(`Holrib slab with height: ${height} cm`);
	
	return  holribSlab;                   
}



//Concrete slabs
//--------------------------------------------------------------------------

function predimConcreteFlatSlab(spanX, spanY) {

	var height = 0;                                              //m
	var spanLi = 0.8 * Math.max(spanX, spanY);

	if (spanLi < 4.29) {
		height = (spanLi / 35 + 0.03) * 100;
	}
	else {
		height = ((Math.pow(spanLi, 2)) / 150 + 0.03) * 100;
	}

	var roundedHeight = Math.ceil(height);
	if (roundedHeight % 2 != 0) {
		roundedHeight = roundedHeight + 1;
	}

	console.log(`Concrete flat slab with height: ${height} cm, rounded height ${roundedHeight} cm`);

	return Math.max((roundedHeight/100), 0.2);                               //return height in m, min height is 0,2 m
}


function predimConcreteSlab(spanX, spanY) {

	var height = 0;                                      //cm
	var l = Math.min(spanX, spanY);                      //m

	height = (2.0 * l + 2) * 0.8;                        //-20% because of continous slab

	var roundedHeight = Math.ceil(height);
	if (roundedHeight % 2 != 0) {
		roundedHeight = roundedHeight + 1;
	}

	roundedHeight = Math.max( roundedHeight, 14);

	console.log(`Concrete slab with height: ${roundedHeight} cm, calculated height ${height} cm`);

	return roundedHeight / 100;                             //return height in m, min height is 0,14 m
}


//Timber slabs
//--------------------------------------------------------------------------

function predimCLTSlab(spanX, spanY, liveLoad, deadLoad) {

	var span = Math.min(spanX, spanY);
	var height;

	//Get matching dead load value
	var matchingDeadLoad = [];
	for (let i = 0; i < KLHCLTSlabs.length; i++) {
		if(deadLoad <= KLHCLTSlabs[i].liveLoad) {
			matchingDeadLoad.push(KLHCLTSlabs[i]);
		}  
	}

	//Get matching live load value
	var matchingLiveLoad;
	for (let i = 0; i < matchingDeadLoad.length; i++) {
		if(liveLoad <= matchingDeadLoad[i].liveLoad) {
			matchingLiveLoad = matchingDeadLoad[i];
			break;
		}  
	}

	height = getSpan(span, matchingLiveLoad)          //Get the correct ribheight for the given span

	//Get the correct span for the matching load
	function getSpan(span, matchingLoad) {
		if(span <= 3) {
			return matchingLoad.height3m;
		}
		else if(span <= 4) {
			return matchingLoad.height4m;
		}
		else if(span <= 5) {
			return matchingLoad.height5m;
		}
		else if(span <= 6) {
			return matchingLoad.height6m;
		}
		else if(span <= 7) {
			return matchingLoad.height7m;
		}
	}

	console.log(`Timber CLT  slab with total height: ${height} cm`);

	return height/100;                   //return height in m
}

function predimRibbedTimberSlab(spanX, spanY, liveLoad, deadLoad) {

	var span = Math.min(spanX, spanY);
	var totalHeight;
	var plateHeight = 11;                                   //Constant plate height of 11 cm for all slabs 
	var ribHeight;

	//Get matching dead load value
	var matchingDeadLoad = [];
	for (let i = 0; i < KLHRibbedSlabs.length; i++) {
		if(deadLoad <= KLHRibbedSlabs[i].deadLoad) {
			matchingDeadLoad.push(KLHRibbedSlabs[i]);
		}  
	}

	//Get matching live load value
	var matchingLiveLoad;
	for (let i = 0; i < matchingDeadLoad.length; i++) {
		if(liveLoad <= matchingDeadLoad[i].liveLoad) {
			matchingLiveLoad = matchingDeadLoad[i];
			break;
		}  
	}

	ribHeight = getSpan(span, matchingLiveLoad)          //Get the correct ribheight for the given span
	
	function getSpan(span, KLHRibbedSlab) {
		if(span <= 6) {
			return matchingLiveLoad.ribHeight6m;
		}
		else if(span <= 7) {
			return matchingLiveLoad.ribHeight7m;
		}
		else if(span <= 8) {
			return matchingLiveLoad.ribHeight8m;
		}
		else if(span <= 9) {
			return matchingLiveLoad.ribHeight9m;
		}
		else if(span <= 10) {
			return matchingLiveLoad.ribHeight10m;
		}
	}

	totalHeight = plateHeight + ribHeight;
	console.log(`Timber ribbed  slab with total height: ${totalHeight} cm, rib height ${ribHeight} cm, plate height ${plateHeight} cm`);

	return totalHeight/100;                   //return height in m
}


//Hybrid slabs
//--------------------------------------------------------------------------

// function predimHBVSlab(spanX, spanY, load) {

// 	var span = Math.ceil( Math.min(spanX, spanY) );
// 	var matchingSpans = HBVRibbedSlabs.filter( function(hbvRibbedSlab) {
//         if(hbvRibbedSlab.span == span ) {
//             return true;
//         }
//     })

// 	var resultingHBVSlab; 
//     for (let i = 0; i < matchingSpans.length; i++) {
//         if(matchingSpans[i].liveLoad >= load ) {
// 			resultingHBVSlab = matchingSpans[i];
// 			break;
//         }
//     }

// 	var totalHeight = resultingHBVSlab.heightConcrete + resultingHBVSlab.heightTimber;

// 	console.log(`HBV beam slab with total height: ${totalHeight} cm, beam height ${resultingHBVSlab.heightTimber} cm, beam width ${resultingHBVSlab.widthTimber} cm, beam distance ${resultingHBVSlab.distance} cm`);

// 	return resultingHBVSlab;
// }

//Predimension of HBV-Slab 
//--------------------------------------------------------------------------
function predimHBVSlab(spanX, spanY, liveLoad, deadLoad) {

	function HBVRibbedSlab(span, liveLoad, heightConcrete, widthTimber, heightTimber, distance) {
		this.span = span;
		this.liveLoad = liveLoad;
		this.heightConcrete = heightConcrete;
		this.widthTimber = widthTimber;
		this.heightTimber = heightTimber;
		this.distance = distance;
	}

	var span = Math.ceil( Math.min(spanX, spanY) );

	//Get matching dead load value
	var matchingDeadLoad = [];
	for (let i = 0; i < HBVRibbedSlabs.length; i++) {
		if(deadLoad <= HBVRibbedSlabs[i].deadLoad) {
			matchingDeadLoad.push(HBVRibbedSlabs[i]);
		}  
	}

	//Get matching live load value
	var matchingLiveLoad;
	for (let i = 0; i < matchingDeadLoad.length; i++) {
		if(liveLoad <= matchingDeadLoad[i].liveLoad) {
			matchingLiveLoad = matchingDeadLoad[i];
			break;
		}  
	}

	//Get matching span value
	var resultingHBVSlab = getSpan(span, matchingLiveLoad); 

	//Function to get the correct span for the matching load
	function getSpan(span, matchingLiveLoad) {
		if(span <= 5) {
			resultingHBVSlab = new HBVRibbedSlab(span, liveLoad, matchingLiveLoad.heightConcrete5m, matchingLiveLoad.widthTimber5m,
														matchingLiveLoad.heightTimber5m, matchingLiveLoad.distance5m);
			// console.log('5m from getSpan');
			return resultingHBVSlab;
		}
		else if(span <= 6) {
			resultingHBVSlab = new HBVRibbedSlab(span, liveLoad, matchingLiveLoad.heightConcrete6m, matchingLiveLoad.widthTimber6m,
														matchingLiveLoad.heightTimber6m, matchingLiveLoad.distance6m);
			// console.log('6m from getSpan');
			return resultingHBVSlab;
		}
		else if(span <= 7) {
			resultingHBVSlab = new HBVRibbedSlab(span, liveLoad, matchingLiveLoad.heightConcrete7m, matchingLiveLoad.widthTimber7m,
														matchingLiveLoad.heightTimber7m, matchingLiveLoad.distance7m);
			// console.log('7m from getSpan');
			return resultingHBVSlab;
		}
		else if(span <= 8) {
			resultingHBVSlab = new HBVRibbedSlab(span, liveLoad, matchingLiveLoad.heightConcrete8m, matchingLiveLoad.widthTimber8m,
														matchingLiveLoad.heightTimber8m, matchingLiveLoad.distance8m);
			// console.log('8m from getSpan');
			return resultingHBVSlab;
		}
		else if(span <= 9) {
			resultingHBVSlab = new HBVRibbedSlab(span, liveLoad, matchingLiveLoad.heightConcrete9m, matchingLiveLoad.widthTimber9m,
														matchingLiveLoad.heightTimber9m, matchingLiveLoad.distance9m);
			// console.log('9m from getSpan');
			return resultingHBVSlab;
		}
		else if(span <= 10) {
			resultingHBVSlab = new HBVRibbedSlab(span, liveLoad, matchingLiveLoad.heightConcrete10m, matchingLiveLoad.widthTimber10m,
														matchingLiveLoad.heightTimber10m, matchingLiveLoad.distance10m);
			// console.log('10m from getSpan');
			return resultingHBVSlab;
		}
	}

	return resultingHBVSlab;
}


//--------------------------------------------------------------------------
//Beams
//--------------------------------------------------------------------------

//Steel Beam
//--------------------------------------------------------------------------

function predimSteelBeam(load, length, distance) {            //IPE

	function SteelBeam(profilHeight, area, shape) {
		this.profilHeight = profilHeight;
		this.area = area;
		this.shape = shape;
	}

	var lineLoad = load * distance; 
	var height;                                                      //cm
	height = Math.pow(50 * lineLoad * Math.pow(length, 2), (1/3)) - 2;

	var name = "";
	var area = 0;
	var profHeight = 0;
	var shape;

	if (height <= IPEProfiles[0].height) {
		name = IPEProfiles[0].id;
		area = IPEProfiles[0].area;
		profHeight = IPEProfiles[0].height;
		shape = IPEProfiles[0].shape;
	}
	else if (height >= IPEProfiles[IPEProfiles.length - 2].height) {
		name = IPEProfiles[IPEProfiles.length - 1].id;
		area = IPEProfiles[IPEProfiles.length - 1].area;
		profHeight = IPEProfiles[IPEProfiles.length - 1].height;
		shape = IPEProfiles[IPEProfiles.length - 1].shape;
	}
	else {
		for (let i = 0; i < IPEProfiles.length - 1; i++) {
			if (IPEProfiles[i].height <= height && height <= IPEProfiles[i + 1].height) {
				name = IPEProfiles[i + 1].id;
				area = IPEProfiles[i + 1].area;
				profHeight = IPEProfiles[i + 1].height;
				shape = IPEProfiles[i + 1].shape;
			}
		}
	}

	// console.log(`Steel beam: Selected Profil for height ${height} cm: ${name} with height ${profHeight} cm and area ${area} cm2`);

	area = area / (100 * 100);							//return area in m2
	profHeight = profHeight / 100;						//return height in m

	var steelBeam = new SteelBeam (profHeight, area, shape);

	return steelBeam;
}


function predimCompositeSteelBeam(load, length, distance) {            //IPE

	function CompositeBeam(profilHeight, area, shape) {
		this.profilHeight = profilHeight;
		this.area = area;
		this.shape = shape;
	}
	var lineLoad = load * distance;

	var height;                                                            //cm
	height = (0.1 * lineLoad * Math.pow((0.8 * length), 2) + 100) / 10 ;     //Check again if right!!

	var name = "";
	var area = 0;
	var profilHeight = 0;
	var shape;

	if (height <= IPEProfiles[0].height) {
		name = IPEProfiles[0].id;
		area = IPEProfiles[0].area;
		profilHeight = IPEProfiles[0].height;
		shape = IPEProfiles[0].shape;
	}
	else if (height >= IPEProfiles[IPEProfiles.length - 2].height) {
		name = IPEProfiles[IPEProfiles.length - 1].id;
		area = IPEProfiles[IPEProfiles.length - 1].area;
		profilHeight = IPEProfiles[IPEProfiles.length - 1].height;
		shape = IPEProfiles[IPEProfiles.length - 1].shape;
	}
	else {
		for (let i = 0; i < IPEProfiles.length - 1; i++) {
			if (IPEProfiles[i].height <= height && height <= IPEProfiles[i + 1].height) {
				name = IPEProfiles[i + 1].id;
				area = IPEProfiles[i + 1].area;
				profilHeight = IPEProfiles[i + 1].height;
				shape = IPEProfiles[i + 1].shape;
			}
		}
	}

	// console.log(`Composite steel beam: Selected Profil for height ${height} cm: ${name} with height ${profilHeight} cm and area ${area} cm2`);

	area = area / (100 * 100);										//return area in m2
	profilHeight = profilHeight/100;								//return height in m 

	var compositeBeam = new CompositeBeam(profilHeight, area, shape);

	return compositeBeam;                                
}


//Concrete Beam
//--------------------------------------------------------------------------

function predimConcreteTBeam(load, length, plateHeight, beamDist) { 
	
	function ConcreteTBeam(beamHeight, area) {
		this.beamHeight = beamHeight;
		this.area = area;
	}
	
	var totalHeight; 														 //cm
	var totalLoad = load + plateHeight/100 * 25;
	totalHeight = 1.2 * length * Math.sqrt(totalLoad * beamDist);                        //load in kN/m

	var roundedHeight = Math.ceil(totalHeight);
	if (roundedHeight % 2 != 0) {
		roundedHeight = roundedHeight + 1;
		if (roundedHeight < 20) {
			roundedHeight = 20;
		}
	}

	var width = totalHeight / 2;                                                      //cm
	var roundedWidth = Math.ceil(width);
	if (roundedWidth % 2 != 0) {
		roundedWidth = roundedWidth + 1;
	}

	var beamHeight = (roundedHeight - plateHeight);

	var area = beamHeight * roundedWidth;
	// console.log(`Concrete T-Beam with total height: ${roundedHeight} cm, calculated height: ${totalHeight} cm, plate height: ${plateHeight} cm, beam height: ${beamHeight}, width: ${roundedWidth} cm, area: ${area} cm2`);
	area = area / ( 100 * 100); 								//return area in m2 
	beamHeight = beamHeight / 100;      						//return beamHeight in m                         

	var concreteTBeam = new ConcreteTBeam(beamHeight, area);

	return concreteTBeam;
}


//Timber Beam
//--------------------------------------------------------------------------
function predimTimberBeam(load, length, distance) {

	function TimberBeam(beamHeight, area) {
		this.beamHeight = beamHeight;
		this.area = area;
	}

	var lineLoad = load * distance;

	var moment = 0.125 * lineLoad * Math.pow(length, 2);

	// console.log('moment:' + moment);

	var maxSigma = ( 0.8 * ( 28 / 1.3 ) ) / 10; 				//kmod * (fk / gammaM) in kN/cm2

	var height = Math.cbrt( 12 * (moment * 100 /  maxSigma) );
	var roundedHeight = Math.ceil(height);
	if (roundedHeight % 2 != 0) {
		roundedHeight = roundedHeight + 1;
	}

	var width = Math.round(0.5 * height, 2);
	var roundedWidth = Math.ceil(width);
	if (roundedWidth % 2 != 0) {
		roundedWidth = roundedWidth + 1;
	}

	var area = roundedHeight * roundedWidth;
	// console.log(`Timber beam with height: ${height} cm, rounded height: ${roundedHeight} cm, width: ${width} cm, rounded width: ${roundedWidth} cm, area: ${area} cm2`);

	area = area / (100 * 100);													//return area in m2
	roundedHeight = roundedHeight / 100;										//return height in m

	var timberBeam = new TimberBeam(roundedHeight, area);

	return timberBeam;
}


function predimTimberBeam1(load, length, distance) {

	function TimberBeam(beamHeight, area) {
		this.beamHeight = beamHeight;
		this.area = area;
	}

	var lineLoad = load * distance;

	var momentSingleSpan = (lineLoad * Math.pow(length, 2)) / 8;               //Single Span
	var momentContinousBeam = (lineLoad * Math.pow(length, 2)) / 10;           //Continous Beam 

	var height = Math.round(5 * Math.sqrt(momentSingleSpan), 2);
	var roundedHeight = Math.ceil(height);
	if (roundedHeight % 2 != 0) {
		roundedHeight = roundedHeight + 1;
	}

	var width = Math.round(0.5 * height, 2);
	var roundedWidth = Math.ceil(width);
	if (roundedWidth % 2 != 0) {
		roundedWidth = roundedWidth + 1;
	}

	var area = roundedHeight * roundedWidth;
	// console.log(`Timber beam with height: ${height} cm, rounded height: ${roundedHeight} cm, width: ${width} cm, rounded width: ${roundedWidth} cm, area: ${area} cm2`);

	area = area / (100 * 100);													//return area in m2
	roundedHeight = roundedHeight / 100;										//return height in m

	var timberBeam = new TimberBeam(roundedHeight, area);

	return timberBeam;
}

//Dummy Timber Beam with 0 result for ribbed timber slab
//--------------------------------------------------------------------------
function predimDummyTimberBeam() {

	function TimberBeam(beamHeight, area) {
		this.beamHeight = beamHeight;
		this.area = area;
	}

	var timberBeam = new TimberBeam(0, 0);

	return timberBeam;
}



//--------------------------------------------------------------------------
//Columns
//--------------------------------------------------------------------------

//Steel Column
//--------------------------------------------------------------------------

function predimSteelColumn(load, length) {

	function SteelColumn(profilHeight, area, shape) {
		this.profilHeight = profilHeight;
		this.area = area;
		this.shape = shape;
	}

	var height;                                                      //cm
	height = Math.round(Math.sqrt(16 * load * length) / 10, 2);

	var name = "";
	var area = 0;
	var profHeight = 0;
	var shape;

	if (height <= HEBProfiles[0].height) {
		name = HEBProfiles[0].id;
		area = HEBProfiles[0].area;
		profHeight = HEBProfiles[0].height;
		shape = HEBProfiles[0].shape;
	}
	else if (height >= HEBProfiles[HEBProfiles.length - 2].height) {
		name = HEBProfiles[HEBProfiles.length - 1].id;
		area = HEBProfiles[HEBProfiles.length - 1].area;
		profHeight = HEBProfiles[HEBProfiles.length - 1].height;
		shape = HEBProfiles[HEBProfiles.length - 1].shape;
	}
	else {
		for (let i = 0; i < HEBProfiles.length - 1; i++) {
			if (HEBProfiles[i].height <= height && height <= HEBProfiles[i + 1].height) {
				name = HEBProfiles[i + 1].id;
				area = HEBProfiles[i + 1].area;
				profHeight = HEBProfiles[i + 1].height;
				shape = HEBProfiles[i + 1].shape;
			}
		}
	}

	// console.log(`Steel column: Selected Profil for height ${height} cm: ${name} with height ${profHeight} cm and area ${area} cm2`);

	area = area / (100 * 100);							//return area in m2
	profHeight = profHeight/100;						//return height in m 

	var steelColumn = new SteelColumn(profHeight, area, shape);

	return steelColumn;                                //return area in m2
}

//Concrete Column
//--------------------------------------------------------------------------
function predimConcreteColumn(load) {

	function ConcreteColumn(columnSideLength, area) {
		this.columnSideLength = columnSideLength;
		this.area = area;
	}

	var sideLength = Math.round(Math.sqrt(0.47 * load), 2);                         //cm

	var roundedSideLength = Math.ceil(sideLength);
	if (roundedSideLength % 2 != 0) {
		roundedSideLength = roundedSideLength + 1;
		if (roundedSideLength < 20) {
			roundedSideLength = 20;
		}
	}
	var area = roundedSideLength * roundedSideLength;                //cm2

	// console.log(`Concrete column with side length: ${sideLength} cm, rounded side length: ${roundedSideLength} cm, area: ${area} cm2`);

	roundedSideLength = roundedSideLength /100;						//return height in m
	area = area / (100 * 100);										//return area in m2

	var concreteColumn = new ConcreteColumn(roundedSideLength, area);

	return concreteColumn;
}

//Timber Column
//--------------------------------------------------------------------------

function predimTimberColumn(load, length) {

	function TimberColumn(columnSideLength, area) {
		this.columnSideLength = columnSideLength;
		this.area = area;
	}

	var sideLength = 0; 

	var matchingLength = [];
	for (let i = 0; i < GlulamColumns.length; i++) {
		matchingLength.push(getLength(length, GlulamColumns[i]));
	}

	for (let i = 0; i < matchingLength.length; i++) {
		if(load < matchingLength[i]) {
			sideLength = GlulamColumns[i].sideLength;
			break;
		}
	}


	if(sideLength == 0){
		// alert('Maximal column load exceeded! \n Reduce load or change material!');
		store.state.columnLoadExceeded = true;
		// console.log('column load exceeded');
	}

	var area = sideLength * sideLength;
	// console.log(`Timber column with side length: ${sideLength} cm, area: ${area} cm2`);
	var timberColumn = new TimberColumn(sideLength, area);

	return timberColumn;

	
	//Get the correct length
	function getLength(length, glulamColumn) {
		if(length <= 3) {
			return glulamColumn.columnLoad3m;
		}
		else if(length <= 3.5) {
			return glulamColumn.columnLoad3_5m;
		}
		else if(length <= 4) {
			return glulamColumn.columnLoad4m;
		}
		else if(length <= 4.5) {
			return glulamColumn.columnLoad4_5m;
		}
		else if(length <= 5) {
			return glulamColumn.columnLoad5m;
		}
		else if(length <= 5.5) {
			return glulamColumn.columnLoad5_5m;
		}
		else if(length <= 6) {
			return glulamColumn.columnLoad6m;
		}
	}
}


function predimTimberColumn1(load, length) {

	function TimberColumn(columnSideLength, area) {
		this.columnSideLength = columnSideLength;
		this.area = area;
	}

	var sideLength;                                                     //cm
	sideLength = Math.Sqrt(load * length);                            //aus Prietz
	// sideLength = Math.round(2.3 * Math.sqrt(load), 2);                  //aus Schneider BT
	var roundedSideLength = Math.ceil(sideLength);

	if (roundedSideLength % 2 != 0) {
		roundedSideLength = roundedSideLength + 1;
	}
	var area = roundedSideLength * roundedSideLength;

	// console.log(`Timber column with side length: ${sideLength} cm, rounded side length: ${roundedSideLength} cm, area: ${area} cm2`);

	roundedSideLength = roundedSideLength / 100;						//return height in m
	area = area / (100 * 100);											//return area in m2

	var timberColumn = new TimberColumn(roundedSideLength, area);

	return timberColumn;
}



//--------------------------------------------------------------------------
//Core
//--------------------------------------------------------------------------

function predimCoreWalls() {
	var height = 30;                //m
	console.log(`Dimension of core wall: ${height} cm`);

	return (height/100);                      //return height in m
}



//--------------------------------------------------------------------------
//Foundation
//--------------------------------------------------------------------------

function predimGroundSlab(buildingHeight, storeyCount) {

	var height = 0;
	height = Math.round(Math.max((buildingHeight * 100) / 30, 10 * storeyCount), 0);    //height in cm 

	if (height % 2 != 0) {
		height = height + 1;
	}

	console.log(`Dimension of groundslab: ${height} cm`);

	return (Math.max(height, 30)) / 100;                   //return height in m
}




//------------------------------------------------------------------------
//Export
//------------------------------------------------------------------------

export { predimConcreteFlatSlab, predimConcreteSlab, predimCLTSlab, predimRibbedTimberSlab,         //Predimension Slab
			predimCompositeSlab, predimHolribSlab, predimHBVSlab,
			predimSteelBeam, predimCompositeSteelBeam, predimTimberBeam, predimTimberBeam1,predimConcreteTBeam,       //Predimension Beam
			predimConcreteColumn, predimSteelColumn, predimTimberColumn,                            //Predimension Column
			predimSlab, predimBeam, predimColumn, predimCoreWalls, predimGroundSlab }               //Predimension Main